<template>
  <div>
    <h1>Мои записи</h1>
    <white-bg>
      <h3>Текущие записи</h3>
      <div style="min-height: 270px">
        <preload-content :loading="!active" min-height="270px">
          <row margin="0 -10px 30px -10px" v-if="active && active.length">
            <grid-item padding="0 10px" xl="4" xs="12" mb="15px" v-for="(recordsItem, idx) in active" :key="idx">
              <record-card
                  :id="recordsItem.master.id"
                  :title="recordsItem.specialization.name"
                  :price="recordsItem.sum"
                  :date="recordsItem.start"
                  :address="recordsItem.coworking.name +` (${recordsItem.coworking.address})`"
                  :status="!!parseInt(recordsItem.status)"
                  :avatar="recordsItem.master.avatar"
                  :name="recordsItem.master.full_name"
                  :number="recordsItem.master.phone"
              />
            </grid-item>
          </row>
          <div v-else class="no-content">
            <h3>Список пуст</h3>
          </div>
        </preload-content>
      </div>

      <h3>Прошедшие записи</h3>
      <div style="min-height: 270px">
        <preload-content :loading="!closed" min-height="270px">
          <row margin="0 -10px" v-if="closed && closed.length">
            <grid-item padding="0 10px" xl="4" xs="12" mb="15px" v-for="(recordsItem, idx) in closed" :key="idx">
              <record-card
                  :id="recordsItem.master.id"
                  :title="recordsItem.specialization.name"
                  :price="recordsItem.sum"
                  :date="recordsItem.start"
                  :address="recordsItem.coworking.name +` (${recordsItem.coworking.address})`"
                  :status="!!parseInt(recordsItem.status)"
                  :avatar="recordsItem.master.avatar"
                  :name="recordsItem.master.full_name"
                  :number="recordsItem.master.phone"
              />
            </grid-item>
          </row>
          <div v-else class="no-content">
            <h3>Список пуст</h3>
          </div>
        </preload-content>
      </div>
    </white-bg>
  </div>
</template>

<script>
import WhiteBg from '@/components/ui/white-bg';
import Row from '@/components/grid/Row';
import GridItem from '@/components/grid/GridItem';
import RecordCard from '@/components/ui/card/record-card';
import PreloadContent from "@/components/ui/preload-content";

export default {
  name: 'WatchPackages',
  components: {PreloadContent, RecordCard, WhiteBg, Row, GridItem},
  mounted() {
    this.loadActive();
    this.loadClosed();
  },
  data() {
    return {
      active: null,
      closed: null,
    }
  },
  methods: {
    loadActive() {
      this.$api.client.record.list({active: true}).then((data) => this.active = data.data);
    },
    loadClosed() {
      this.$api.client.record.list({closed: true}).then((data) => this.closed = data.data);
    }
  }
}
</script>

<style scoped lang="scss">
h1 {
  display: none;
}

h3 {
  margin-bottom: 15px;
}

.no-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 270px
}

@media screen and (max-width: 991px) {
  .row {
    margin-bottom: 15px !important;
  }
  h1 {
    margin-top: -10px;
    margin-bottom: 15px;
    padding-top: 0;
    display: block;
    font-size: 24px;
    line-height: 1.33;
    color: #383838;
  }
  h3 {
    font-size: 20px;
  }

  .whiteBg {
    padding: 15px !important;
    margin: 0 -15px !important;
  }
}

</style>
